export const sortAscendingByKey = (key) => (a, b) => {
  if (a[key] < b[key]) return -1
  if (a[key] > b[key]) return 1
  return 0
}

export const sortAscendingFarmName = sortAscendingByKey("farmName")
